<template>
    <div class="app-root">
        <router-view></router-view>

        <!-- global auth alerts -->
        <notifications
            group="auth"
            :duration="5000"
            :width="400"
            position="top right"
            classes="v-notification"
            class="mx-3 mt-2"
        ></notifications>

        <!-- global pages alerts -->
        <notifications
            group="pages"
            :duration="10000"
            :width="500"
            position="bottom left"
            classes="v-notification"
            class="mx-3 mb-2"
        ></notifications>
    </div>
</template>

<script>
export default {
    data() {
        return {
            rightDrawer: false
        }
    },
    created() {
        // add app events
    },
    methods: {},

    computed: {}
}
</script>
